export default __webpack_public_path__ + "static/media/adobe-xd.fa7a22d2.svg";